module.exports = __webpack_public_path__ + "media/images/vp/parallax.02.2-a9dcdc947f47a96b5fb8ec95f61df3be.png";